/* eslint-disable react-hooks/exhaustive-deps */
import Badge from '@panel/commons/lib/badge';
import React from 'react';
import styled, { css } from 'styled-components';
import { useObserver } from 'mobx-react';
import { useSelector } from 'react-redux';
import { ActivitySelectors } from '../../../state/ducks/userActivity';

const deskTopStyle = css`
  position: absolute;
  right: 4px;
  top: 10px;
`;

const mobileStyle = css`
  position: relative;
  margin-left: 6px;
  margin-top: -15px;
`;

const BadgeWrapper = styled.div`
  ${({ isMobile }) => (isMobile ? mobileStyle : deskTopStyle)}
  >span {
    min-width: 8px;
    height: 8px;
    padding: 0;
  }
`;

const MessageCounter = ({ isMobile = false }) => {
  const messageData = useSelector(ActivitySelectors.getMessageActivityState);

  return useObserver(() => (
    <BadgeWrapper isMobile={isMobile}>
      {messageData.counter !== null && messageData.counter > 0 && <Badge value='' />}
    </BadgeWrapper>
  ));
};

export default MessageCounter;
